import { render, staticRenderFns } from "./TrainingStylistsForm.vue?vue&type=template&id=dcd36f7a&"
import script from "./TrainingStylistsForm.vue?vue&type=script&lang=js&"
export * from "./TrainingStylistsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports